import React, { useEffect, useRef } from "react";
import { StLink } from "../../models/testSteps/stLink";
import {
  Grid,
  TextField,
  MenuItem,
  Button,
  Typography,
  Box
} from "@mui/material";

interface Props {
  data: StLink;
  onChange: (updated: StLink) => void;
  setIsValid: (valid: boolean) => void;
  numberOfStLinks: number;
}

const EditStLinkForm: React.FC<Props> = ({ data, onChange, setIsValid, numberOfStLinks }) => {
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        const isValid = data.name.trim() !== "" && data.firmware_path !== undefined && data.firmware_path.trim() !== "" && data.firmware_data !== undefined && data.firmware_data.trim() !== "" && data.st_link_index !== undefined;
        setIsValid(isValid);
    }, [data, setIsValid]);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                const base64 = (reader.result as string).split(',')[1];
                onChange({
                    ...data,
                    firmware_path: file.name,
                    firmware_data: base64,
                });
            };
            reader.readAsDataURL(file);
        }
    };

    const handleRemoveFile = () => {
        onChange({
            ...data,
            firmware_path: "",
            firmware_data: "",
        });
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

  return (
    <Grid container spacing={2} mt={1}>
      <Grid size={12}>
        <TextField
          label="Name"
          fullWidth
          value={data.name}
          onChange={(e) => onChange({ ...data, name: e.target.value })}
        />
      </Grid>
      <Grid size={12}>
        <TextField
          select
          fullWidth
          label="ST-Link Index"
          value={data.st_link_index}
          onChange={(e) => onChange({ ...data, st_link_index: parseInt(e.target.value) })}
        >
          {Array.from({ length: numberOfStLinks }, (_, i) => (
            <MenuItem key={i+1} value={i+1}>ST Link Nr. {i+1}</MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid size={12}>
        <Box display="flex" alignItems="center" gap={2}>
          <Button variant="outlined" component="label">
            Hexfile auswählen
            <input
              type="file"
              accept=".hex"
              hidden
              onChange={handleFileChange}
              ref={fileInputRef}
            />
          </Button>
          {data.firmware_path && (
            <>
              <Typography>{data.firmware_path}</Typography>
              <Button color="error" onClick={handleRemoveFile}>
                Entfernen
              </Button>
            </>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default EditStLinkForm;
